import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { AfterViewInit, ChangeDetectorRef, Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { NgScrollbar } from 'ngx-scrollbar';
import { finalize, map } from 'rxjs';
import { DialogFiltroGenericoComponent } from 'src/app/components/dialog-filtro-generico/dialog-filtro-generico.component';
import { Filters } from 'src/app/components/lista-tabellare/classes/lista-tabellare-data-source';
import { SpinnerOverlayComponent } from 'src/app/components/spinner-overlay/spinner-overlay.component';
import { Impatto, ImpattoService } from 'src/app/services/impatto/impatto.service';
import { SettoriService } from 'src/app/services/settori/settori.service';
import { UtilityService } from 'src/app/services/utility/utility.service';

@Component({
  selector: 'app-dialog-seleziona-impatti-dd',
  standalone: false,

  templateUrl: './dialog-seleziona-impatti-dd.component.html',
  styleUrl: './dialog-seleziona-impatti-dd.component.scss',
})
export class DialogSelezionaImpattiDdComponent implements AfterViewInit {
  @ViewChild('scrollDisponibili') scrollDispobibili!: NgScrollbar;
  @ViewChild('scrollSelezionate') scrollSelezionate!: NgScrollbar;
  @ViewChild('scrollDialog') scrollDialog!: NgScrollbar;

  private _filtri: { [key: string]: any }[] = [];

  public arrayImpattiSel: Impatto[] = [];
  public arrayImpattiSelFiltrati: Impatto[] = [];
  private _valoriFiltro: Filters[] = [];
  private _valoriFiltroSelezionati: Filters[] = [];
  public arrayImpattiDisponibili: Impatto[] = [];
  public loadingDisponibili: boolean = false;

  constructor(
    public dialog: MatDialog,
    private readonly impattoService: ImpattoService,
    private readonly cdRef: ChangeDetectorRef,
    public dialogRef: MatDialogRef<DialogSelezionaImpattiDdComponent>,
    private readonly settoriService: SettoriService,
    private readonly utilityService: UtilityService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      arraySelezioinati: Impatto[];
    },
  ) {}

  ngAfterViewInit(): void {
    this._valoriFiltro = [];
    this._valoriFiltroSelezionati = [];

    this.arrayImpattiSel = this.data.arraySelezioinati;
    this._getImpatti();

    this.arrayImpattiSelFiltrati = [...this.arrayImpattiSel];

    this.cdRef.detectChanges();
  }

  dropImpatti(event: CdkDragDrop<Impatto[]>) {
    const obj = this.dropElementi(event, this.arrayImpattiSel, this.arrayImpattiSelFiltrati);

    this.arrayImpattiSel = obj.arrayElementiSel;
    this.arrayImpattiSelFiltrati = obj.arrayElementiSelFiltrati;
  }

  /**
   * Metodo generale che mi fa il drag and drop e sorting su liste filtrate e non.
   * @param event evento del drag & drop su quale azionare
   * @param arrayElementiSel
   * @param arrayElementiSelFiltrati
   * @returns oggetto con gli array calcolati
   */
  dropElementi(
    event: CdkDragDrop<any[]>,
    arrayElementiSel: any[],
    arrayElementiSelFiltrati: any[],
  ) {
    // Calcolo gli elementi nascosti dal filtro
    const elementiNascostiDalFiltro = arrayElementiSel.filter((elem1) => {
      return !arrayElementiSelFiltrati.some((elem2) => elem2.id === elem1.id);
    });

    // Funzione per ottenere indice non filtrato
    const getIndexNonFiltrato = (id: string) =>
      arrayElementiSel.findIndex((elem) => elem?.id === id);

    // Funzione per applicare il filtro iniziale
    const ripristinaFiltro = () => {
      arrayElementiSelFiltrati = arrayElementiSelFiltrati.filter((elem2) => {
        return !elementiNascostiDalFiltro.some((elem1) => elem1.id === elem2.id);
      });
    };

    const isSorting = event.previousContainer === event.container;
    const isAzioneSuSelezionati = event.container.data.every((item1) =>
      arrayElementiSel.some((item2) => item2.id === item1.id),
    );

    // Caso: Comportamento con filtro
    if (elementiNascostiDalFiltro.length) {
      if (isSorting) {
        // Sorting nella lista filtrata

        if (isAzioneSuSelezionati) {
          /*  Mi calcolo Index elemeno sulla lista non filtrata
             Perchè se ho filtrato vuoldire che gli indici in visualizzazione
             non corrispondono più con quelli originali per fare il sorting */
          const idForIdx = arrayElementiSelFiltrati[event.previousIndex]?.id;
          const findIdx = getIndexNonFiltrato(idForIdx);

          moveItemInArray(arrayElementiSel, findIdx, event.currentIndex);
          moveItemInArray(arrayElementiSelFiltrati, event.previousIndex, event.currentIndex);
        } else {
          moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
        }
      } else {
        // Sono in lista filtrata e faccio drag and drop

        if (isAzioneSuSelezionati) {
          // Drag and drop da DISPONIBILI a SELEZIONATI

          /* Prendo l'id dell elemento sopra a quello spostato, Per avere un riferimento di posizione 
             Questo perchè quando sposto un elemento lo posso rilasciare in qualsisi posizione, quindi 
            prendento un indice di riferimento, quando rimuovo i filtri, l'elemento spostato andra sotto quel
            indice di riferimento */
          const idElemSopra = arrayElementiSelFiltrati[event.currentIndex - 1]?.id;

          /* Tovo l'indice corretto per la lista non filtrata. Ovvero se nella lista filtratra ho spostato
           un elemento sotto [id : 1] allora mi prendo l'id del elemento sopra [id 1 - 1] e cerco l'id
           trovato l'id del elemento nella lista non fitlrata mi prendo index di spostamento sommando al indice trovato + 1 */
          const findIdx = getIndexNonFiltrato(idElemSopra) + 1;

          // Mi inserisco l'elemento nella posizione corretta nella lista non filtrata
          transferArrayItem(
            event.previousContainer.data,
            event.container.data,
            event.previousIndex,
            findIdx,
          );

          // Mi inserisco l'elemento anche nella lista filtrata, sul indice selezionato dall'interfaccia perhcè corrisponde.
          arrayElementiSelFiltrati.splice(event.currentIndex, 0, arrayElementiSel[findIdx]);

          // Rimuovo gli elementi nascosti per ritornare al filtro di prima
          ripristinaFiltro();
        } else {
          // Drag and drop da SELEZIONATI a DISPONIBILI

          // Mi trovo l'indice della lista non filtrata, questo perchè event.previousIndex mi risulta l'indice della lista filtrata
          const idxListaNonFiltrata = getIndexNonFiltrato(
            arrayElementiSelFiltrati[event.previousIndex].id,
          );

          //Rimuovo l'elemento che ho spostato dalla lista filtrata
          arrayElementiSelFiltrati = arrayElementiSelFiltrati.filter(
            (item) => item.id !== event.previousContainer.data[idxListaNonFiltrata].id,
          );

          // Trasferisco l'elemento con l'indice corretto
          transferArrayItem(
            event.previousContainer.data,
            event.container.data,
            idxListaNonFiltrata,
            event.currentIndex,
          );
        }
      }
    } else {
      // Caso: Comportamento regolare senza filtro
      arrayElementiSelFiltrati = arrayElementiSel; // stesso riferimento di memoria

      if (isSorting) {
        moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
      } else {
        transferArrayItem(
          event.previousContainer.data,
          event.container.data,
          event.previousIndex,
          event.currentIndex,
        );
      }
    }

    const obj = {
      arrayElementiSelFiltrati: arrayElementiSelFiltrati,
      arrayElementiSel: arrayElementiSel,
    };

    return obj;
  }

  /**
   * Metodo che mi crea un oggetto per visualizzare i dati nel componente di chip
   * @param getTags
   * @returns
   */
  private metodoGetTagsPerChip(getTags: any) {
    return (ricerca: string | undefined, elementiPreSelezionati?: string[]) =>
      this.utilityService._getTagsPerFiltro(ricerca, elementiPreSelezionati, getTags).pipe(
        map((tags: string[]) =>
          tags.map((tag, index) => ({
            id: index,
            descrizione: tag,
          })),
        ),
      );
  }

  public apriFiltroSelezionati(filtroFrom: string) {
    // Uso un oggetto per mappare i casi e le funzioni corrispondenti
    const filterActions = {
      impatti: () =>
        this._configuraFiltri(
          'titoloFiltroSelezione',
          'tagFiltroSelezione',
          'settoreFiltroSelezione',
          this.metodoGetTagsPerChip(this.impattoService.getImpattiTags(0, 1000)),
        ),
    };

    // Tipo per le chiavi dell'oggetto filterActions
    type FilterActionsKey = keyof typeof filterActions;

    // Verifica se la chiave fornita è valida
    if (filtroFrom in filterActions) {
      this._filtri = filterActions[filtroFrom as FilterActionsKey]();
    }

    const dialogFiltro = this.dialog.open(DialogFiltroGenericoComponent, {
      data: {
        filtri: this._filtri,
        valoriFiltro: this._valoriFiltroSelezionati,
      },
      panelClass: ['dialog-container'],
      disableClose: false,
      width: '50%',
      maxHeight: '95%',
      autoFocus: false,
    });

    dialogFiltro.afterClosed().subscribe((result) => {
      if (result) {
        this._valoriFiltroSelezionati = result.filtri;

        this.getElementiSelezionati();
      }
    });
  }

  // Prima, definisco un metodo per configurare i filtri comuni:
  private _configuraFiltri(filtro1: string, filtro2: string, filtro3: string, metodoService: any) {
    return [
      {
        titolo: filtro1.includes('titolo') ? 'Titolo' : 'Descrizione',
        forControlName: filtro1,
        input: 'text',
        larghezza: 3,
      },
      {
        forControlName: filtro3,
        input: 'multiple-option',
        titolo: 'Settore',
        descValueOption: 'titolo',
        fnDatiOption: () =>
          this.settoriService.getSettori(0, 1000).pipe(map((value) => value?.content || [])),
        idValueOption: 'id',
        riempi: true,
      },
      {
        titolo: 'TAG',
        forControlName: filtro2,
        input: 'multiple-option-chip',
        riempi: true,
        larghezza: 3,
        fnDatiOption: metodoService,
        idValueOption: 'descrizione',
        descValueOption: 'descrizione',
        numeroRecOptions: Infinity,
      },
    ];
  }

  getElementiSelezionati() {
    if (!this._valoriFiltroSelezionati.length) {
      this.arrayImpattiSelFiltrati = [...this.arrayImpattiSel];
    } else {
      let arrayFiltrato: any;

      arrayFiltrato = this.arrayImpattiSel;

      if (!arrayFiltrato) {
        return;
      }

      arrayFiltrato = arrayFiltrato.filter((elemento: any) => {
        return this._valoriFiltroSelezionati.every((valoreFiltro) => {
          if (valoreFiltro.chiave === 'titoloFiltroSelezione') {
            return elemento.titolo.toLowerCase().includes(valoreFiltro.values[0].toLowerCase()); // Controlla se il titolo include il valore
          } else if (valoreFiltro.chiave === 'descrizioneFiltroSelezione') {
            return elemento.descrizione
              .toLowerCase()
              .includes(valoreFiltro.values[0].toLowerCase()); // Controlla se il descrizione include il valore
          } else if (valoreFiltro.chiave === 'tagFiltroSelezione') {
            return valoreFiltro.values.some((valore) => elemento.tag?.includes(valore)); // Controlla se uno dei tag corrisponde
          } else if (valoreFiltro.chiave === 'nomeBreveFiltroSelezione') {
            return elemento.nomeBreve.toLowerCase().includes(valoreFiltro.values[0].toLowerCase()); // Controlla se il nome breve include il valore
          } else if (valoreFiltro.chiave === 'settoreFiltroSelezione') {
            return elemento.settori?.some((settore: any) =>
              valoreFiltro.values.includes(settore.id),
            ); // Controlla se almeno un settore corrisponde
          }
          return true; // Se il filtro non corrisponde a nessuna chiave, non filtrare
        });
      });

      this.arrayImpattiSelFiltrati = arrayFiltrato;
    }
  }

  public apriFiltro(filtroFrom: string) {
    // Uso un oggetto per mappare i casi e le funzioni corrispondenti
    const filterActions = {
      impatti: () =>
        this._configuraFiltri(
          'titolo',
          'tag',
          'settori',
          this.metodoGetTagsPerChip(this.impattoService.getImpattiTags(0, 1000)),
        ),
    };

    // Tipo per le chiavi dell'oggetto filterActions
    type FilterActionsKey = keyof typeof filterActions;

    // Verifica se la chiave fornita è valida
    if (filtroFrom in filterActions) {
      this._filtri = filterActions[filtroFrom as FilterActionsKey]();
    }

    const dialogFiltro = this.dialog.open(DialogFiltroGenericoComponent, {
      data: {
        filtri: this._filtri,
        valoriFiltro: this._valoriFiltro,
      },
      panelClass: ['dialog-container'],
      disableClose: false,
      width: '50%',
      maxHeight: '95%',
      autoFocus: false,
    });

    dialogFiltro.afterClosed().subscribe((result) => {
      if (result) {
        this._valoriFiltro = result.filtri;
        this._getImpatti();
      }
    });
  }

  private _getImpatti() {
    this.loadingDisponibili = true;
    this.impattoService
      .getImpatti(0, 1000, undefined, this._valoriFiltro)
      .pipe(
        finalize(() => {
          setTimeout(() => {
            this.scrollSelezionate.update();

            this.scrollDispobibili.update();
          }, 0);

          this.loadingDisponibili = false;
        }),
      )
      .subscribe({
        next: (esito) => {
          this.arrayImpattiDisponibili = esito.content || [];

          this.arrayImpattiDisponibili = this.arrayImpattiDisponibili.filter(
            (impattoSel) => !this.arrayImpattiSel.some((item2) => impattoSel.id === item2.id),
          );
        },
        error: (err) => {
          console.error(err);
        },
      });
  }

  salva() {
    this.dialogRef.close(this.arrayImpattiSel);
  }
}
